// Domain constants/enums for the observable-document resource (relocated from the legacy Model in wave 4.3 ahead of models/ deletion).

export const EXTRACTION_STATES = {
  'ExtractionState.UPLOADED': 1, // probably won't ever see this state
  'ExtractionState.DISPATCHED': 2,
  'ExtractionState.PROCESSING': 3,
  'ExtractionState.INVALID': 3,
  'ExtractionState.FAILED': 3,
  'ExtractionState.PROCESSED': 4,
  'ExtractionState.DERELICT': 4,
};
